// Validation de numéro de téléphone (Bénin) — règle IDENTIQUE au backend
// (PatientRequest.@Pattern, ^01[4569]\d{7}$). Commence par 01, puis un chiffre
// ∈ {4,5,6,9}, puis 7 chiffres → 10 chiffres au total.
export const PHONE_REGEX = /^01[4569]\d{7}$/;

/**
 * Vrai si la valeur est vide (champ facultatif → accepté) OU au bon format.
 * On ne valide ici que le FORMAT, identiquement pour les deux numéros ; la
 * présence du téléphone principal reste imposée côté serveur (@NotBlank).
 */
export const isValidPhoneIfPresent = (value?: string): boolean => {
  const v = (value ?? "").trim();
  return v === "" || PHONE_REGEX.test(v);
};
